<template>
  <div class="c-group g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline" size="18"></Icon> 选择投放账号 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content">
      <moduler v-for="item in subModules" :key="item.id" :name="item.href" :title="item.name">
        <!-- 广告账号选择 -->
        <div v-if="item.href === 'group_creat'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">批量方案</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="campaign.subject" type="button" @on-change="changeSubject">
                <Radio :label="1">一个推广计划对应多个计划创意</Radio>
                <Radio :label="2">一个推广计划对应一个计划创意</Radio>
              </RadioGroup>
              <Button type="primary" @click="showCompaignModal" style="margin-left: 22px">新建推广计划</Button>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">推广目标</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="campaign.campaign_type" type="button" @on-change="changeCampaignType">
                <Radio :label="2">应用下载</Radio>
                <Radio :label="5">销售线索收集</Radio>
                <Radio :label="32">微信小程序/小游戏</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放场景</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="campaign.bid_type" type="button" @on-change="changeBidType">
                <Radio :label="0">常规投放</Radio>
                <Radio :label="1">最大转化投放</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放方式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="campaign.deliveryMethod" type="button" @on-change="changeDeliveryType">
                <Radio :label="1">常规手动投放</Radio>
                <Radio :label="3">全自动投放</Radio>
              </RadioGroup>
              <p style="margin-top: 10px" v-if="campaign.deliveryMethod === 3">
                注：全自动化投放的推广计划下面已经有计划了，不允许再创建计划
              </p>
            </Col>
          </Row>

          <template v-if="campaign.subject === 2">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">推广计划预算</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="campaign.budget" type="button" @on-change="changBudget">
                  <Radio :label="0" :disabled="campaign.bid_type === 1">不限</Radio>
                  <Radio :label="1">指定预算</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="campaign.budget">
              <Col span="3" class="col-item">
                <!-- <span class="item-field"></span> -->
              </Col>
              <Col span="12">
                <Input
                  v-model="campaign.day_budget"
                  placeholder="请输入500-100,000,000数值"
                  style="width: 320px"
                  @on-blur="inputTrim('day_budget', campaign.day_budget, campaign, false)"
                >
                  <span slot="append" style="padding: 0 6px"> 元 </span>
                </Input>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="campaign.deliveryMethod === 1">
              <Col span="3" class="col-item">
                <span class="item-field">
                  <Tooltip placement="top" max-width="300">
                    <span style="position: top:-3px;">自动操盘<i class="el-icon-info"></i></span>
                    <div slot="content">
                      <p>系统将会进行如下调控：</p>
                      <p>·自动关停效果不佳的计划;</p>
                      <p>·基于设置的定向，探索优质人群;</p>
                      <p>·自动调整投放时段，选择更合适的投放时段;</p>
                      <p>·自动调配组预算，降低空耗，计划预算不会被突破;</p>
                    </div>
                  </Tooltip>
                </span>
              </Col>
              <Col span="12">
                <i-switch v-model="campaign.auto_adjust" :true-value="1" :false-value="0"></i-switch>
                <span>&ensp;使用自动操盘建议设置预算</span>
              </Col>
            </Row>
          </template>

          <Row class="row-item" :gutter="12" v-if="campaign.subject === 1 && campaignIds.length">
            <Col span="3" class="col-item">
              <span class="item-field">账号/推广计划选择</span>
            </Col>
            <Col span="20">
              <Spin size="large" fix v-if="show" />
              <select-group
                v-else
                v-model="multCampaign"
                account
                :data="campaignIds"
                :media="media"
                :bid-type="campaign.bid_type"
                :type="campaign.campaign_type"
                :delivery-type="deliveryType"
                @on-select="selectAll"
              />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="campaign.subject === 2 && accountIds.length">
            <Col span="3" class="col-item">
              <span class="item-field">账号选择</span>
            </Col>
            <Col span="16">
              <Spin size="large" fix v-if="show" />
              <select-account v-else v-model="multAccount" :data="accountIds" :media="media" @on-select="selectAll" />
            </Col>
          </Row>
        </div>
      </moduler>
    </div>

    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button type="primary" :loading="loading" @click.stop="submitToNext">
            <span v-if="!loading">下一步</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>

    <!-- 批量增加广告组 -->
    <Modal v-model="compaignModal" width="1120" title="新建推广计划" :transfer="false" @on-visible-change="bindGetData">
      <Form :label-width="180" :style="{ maxHeight: '530px', overflowY: 'auto' }">
        <FormItem label="计划投放账号">
          <el-select
            v-model="campaignModalForm.account_ids"
            :popper-append-to-body="false"
            multiple
            filterable
            placeholder="请选择计划投放账号"
            style="width: 420px"
          >
            <el-option v-for="item in originData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </FormItem>
        <FormItem label="推广目标">
          <RadioGroup v-model="campaignModalForm.campaign_type" type="button" @on-change="handleCampaignType">
            <Radio :label="2">应用下载</Radio>
            <Radio :label="5">销售线索收集</Radio>
            <Radio :label="32">微信小程序/小游戏</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="投放场景">
          <RadioGroup v-model="campaignModalForm.bid_type" type="button" @on-change="changeModalFormBidType">
            <Radio :label="0">常规投放</Radio>
            <Radio :label="1">最大转化投放</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="推广计划预算">
          <RadioGroup v-model="campaignModalForm.budget" type="button" @on-change="changeModalFormBudget">
            <Radio :label="0" :disabled="campaignModalForm.bid_type === 1">不限</Radio>
            <Radio :label="1">指定预算</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="" v-if="campaignModalForm.budget">
          <Input
            v-model="campaignModalForm.day_budget"
            placeholder="请输入500-100,000,000数值"
            style="width: 352px"
            @on-blur="inputTrim('day_budget', campaignModalForm.day_budget, campaign, false)"
          >
            <span slot="append" style="padding: 0 6px"> 元 </span>
          </Input>
        </FormItem>

        <FormItem label="投放方式">
          <RadioGroup v-model="campaignModalForm.deliveryMethod" type="button">
            <Radio :label="1">手动投放</Radio>
            <!-- <Radio :label="2">智能操盘</Radio> -->
            <Radio :label="3">全自动投放</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem v-if="campaignModalForm.deliveryMethod === 2">
          <span slot="label"
            >自动调控

            <Tooltip placement="top" max-width="300">
              <i class="el-icon-info"></i>
              <div slot="content">
                <p>系统将会进行如下调控：</p>
                <p>·自动关停效果不佳的广告;</p>
                <p>·基于设置的定向，探索优质人群;</p>
                <p>·自动调整投放时段，选择更合适的投放时段;</p>
                <p>·自动调配组预算，降低空耗，计划预算不会被突破;</p>
              </div>
            </Tooltip>
          </span>
          <i-switch disabled v-model="campaignModalForm.auto_adjust" :true-value="1" :false-value="0"></i-switch>
        </FormItem>

        <FormItem label="批量建立">
          <i-switch v-model="campaignModalForm.batch" @on-change="changeBatch" />
        </FormItem>
        <FormItem v-if="campaignModalForm.batch" label="推广计划数量">
          <input-range v-model="campaignModalForm.range" :min="1" :max="999" :step="100" />
        </FormItem>
        <FormItem label="推广计划名称">
          <input-len v-model="campaignModalForm.campaign_name" placeholder="最大110个字符，1个中文等于2个字符" :max="110" width="520" />
        </FormItem>
        <FormItem label="推广计划状态">
          <i-switch v-model="campaignModalForm.operation" size="large" true-value="enable" false-value="disable">
            <span slot="open">开启</span>
            <span slot="close">关闭</span>
          </i-switch>
        </FormItem>
      </Form>

      <template slot="footer">
        <Button type="default" @click="onModalCancel">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="asyncSelect">
          <span v-if="!submitLoading">确定</span>
          <span v-else>提交中...</span>
        </Button>
      </template>
    </Modal>

    <Modal v-model="result" width="620" title="推广计划创建结果" okText="知道了">
      <p>
        成功创建 <strong style="color: green">{{ resultData.length - fail }}</strong> 条,失败
        <strong style="color: red">{{ fail }}</strong> 条
      </p>
      <Table :columns="resultColumns" :data="resultData" :max-height="420"></Table>
    </Modal>
  </div>
</template>
<script>
import moment from 'moment'
import mixin from './mixin'
import { setSession, setLocal, getLocal } from '@/common/js/api'
import { isArray, isEmpty, timeout, getTime, getByteLen, deepCopy, formatDate, findCheck, getIdOfData } from '@/common/js/utils'
import InputRange from '@/components/input/input-number-range'
import SelectGroup from './components/group/select-group'
import SelectAccount from './components/group/select-account'

import { adAccount } from '@/api/common.model'
import { addCampaignBatch } from '@/api/kuaishou.local.model'
import constraintActionData from '@/data/kuaishou/constraintActionData'

const getForm = () => {
  return {
    subject: 1, // 仅批量广告
    bid_type: 0,

    campaign_type: Number(getLocal('kuaishou_campaign_type')) || 2,
    campaign_name: '',
    budget: 0,
    day_budget: null,
    auto_adjust: 0, // 自动调控
    deliveryMethod: 1, // 投放方式
    // constraint_action_type: 0,
    operation: 'disable',
    batch: false,
    range: ['', ''],
    account_ids: []
  }
}

export default {
  name: 'ksLocalGroup',
  mixins: [mixin],
  components: {
    InputRange,
    SelectGroup,
    SelectAccount
  },
  computed: {
    deliveryType() {
      let type = ''
      const { deliveryMethod } = this.campaign
      if (deliveryMethod === 1) type = 'normal'
      if (deliveryMethod === 3) type = 'automatic'
      return type
    },
    multCampaign() {
      const arr = []
      this.campaignIds.forEach((ret) => {
        if (isArray(ret.children)) {
          ret.children.forEach((met) => {
            if (met.check) arr.push(met)
          })
        }
      })
      return arr
    },
    multAccount() {
      return findCheck(this.accountIds)
    },
    fail() {
      return this.resultData.filter((ret) => ret.status).length
    }
  },
  data() {
    return {
      show: null,
      compaignModal: false, // 批量弹窗
      submitLoading: null, // 异步加载
      campaignIds: [],
      accountIds: [],
      originData: [], // 原始数据用于还原
      constraintActionData, // 浅层约束目标枚举值
      campaign: getForm(),
      campaignModalForm: { ...getForm(), auto_adjust: 1 },
      result: null,
      resultColumns: [
        {
          maxWidth: 80,
          title: '媒体',
          key: 'media_name'
        },
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '结果',
          tooltip: true,
          key: 'msg'
        }
      ],
      resultData: []
    }
  },
  methods: {
    changeCampaignType() {
      this.preloadData()
    },
    handleCampaignType() {
      const date = formatDate(new Date(), 'MMdd')
      const time = formatDate(new Date(), 'hh:mm')
      let campaign_name = ''

      const { campaign_type } = this.campaignModalForm
      if (campaign_type === 2) campaign_name = '应用推广'
      if (campaign_type === 5) campaign_name = '销售线索'
      if (campaign_type === 32) campaign_name = '微信小游戏'

      this.$set(this.campaignModalForm, 'campaign_name', `${campaign_name}_${date}_${time}`)
    },
    changeSubject() {
      this.campaignIds = deepCopy(this.originData).map((ret) => {
        return { id: ret.id, name: ret.name, children: [] }
      })
      this.accountIds = deepCopy(this.originData).map((ret) => {
        return { id: ret.id, name: ret.name, children: [] }
      })
      this.campaign.budget = 0
      this.campaign.bid_type = 0
      this.campaign.day_budget = ''
    },
    changeBatch(val) {
      if (val) this.campaignModalForm.range = ['', '']
    },
    bindGetData(val) {
      this.campaign.budget = 0
      this.campaign.bid_type = 0
      this.campaign.day_budget = null
      // this.campaign.constraint_action_type = 0
      if (val) {
        const date = formatDate(new Date(), 'MMdd')
        const time = formatDate(new Date(), 'hh:mm')
        let campaign_name = ''
        const { campaign_type } = this.campaignModalForm

        if (campaign_type === 2) campaign_name = '应用推广'
        if (campaign_type === 5) campaign_name = '销售线索'
        if (campaign_type === 32) campaign_name = '微信小游戏'

        // this.campaign.campaign_name = `${this.campaign.campaign_type === 2 ? '应用推广' : '销售线索'}_${date}_${time}`
        this.campaignModalForm.campaign_name = `${campaign_name}_${date}_${time}`
      } else {
        this.campaignModalForm = { ...getForm(), auto_adjust: 1 }
      }
    },
    resetValid() {
      this.formErr = false
      this.errRes = []
    },
    changBudget() {
      this.campaign.day_budget = null
    },
    changeModalFormBudget() {
      this.campaignModalForm.day_budget = null
    },
    changeDeliveryType() {
      this.preloadData()
    },
    changeBidType(val) {
      this.campaign.budget = val
      this.preloadData()
    },
    changeModalFormBidType(val) {
      this.campaignModalForm.budget = val
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      // 无限递归
      const setAllChecked = (data, check) => {
        data.forEach((ret) => {
          if (ret.children && ret.children.length) setAllChecked(ret.children, check)
          if (!ret.disabled) this.$set(ret, 'check', check)
        })
      }
      if (current) {
        const item = getIdOfData(list, current)
        data = item.children
      } else data = list
      if (isArray(data)) setAllChecked(data, check)
    },
    preloadData() {
      this.show = true
      adAccount({
        mediaId: this.media,
        authFlag: 1
      }).then((data) => {
        this.show = false
        if (isArray(data)) {
          this.originData = JSON.parse(JSON.stringify(data))
          this.campaignIds = deepCopy(this.originData).map((ret) => {
            return { id: ret.id, name: ret.name, children: [], xhr: false, disabled: false }
          })
        }
      })
    },
    showCompaignModal() {
      this.compaignModal = true
    },
    onModalCancel() {
      this.compaignModal = false
    },
    asyncSelect() {
      const [start_num, end_num] = this.campaignModalForm.range
      if (!this.campaignModalForm.account_ids.length) {
        this.$Message.error('投放账号不能为空！')
        return
      }
      if (this.campaignModalForm.batch && (isEmpty(start_num) || isEmpty(end_num))) {
        this.$Message.error('批量区间数不能为空！')
        return
      }
      if (getByteLen(this.campaignModalForm.campaign_name) > 110) {
        this.$Message.error('推广计划名称不能多于110个字符！')
        return
      }
      if (this.campaignModalForm.budget === 1) {
        if (!this.campaignModalForm.day_budget) {
          this.$Message.error('推广计划预算不能为空！')
          return
        } else if (
          Number(this.campaignModalForm.day_budget) < 500 ||
          Number(this.campaignModalForm.day_budget) > 100000000 ||
          isNaN(Number(this.campaignModalForm.day_budget))
        ) {
          this.$Message.error('推广计划预算请输入500-100,000,000数值！')
          return
        }
      }

      const params = JSON.parse(JSON.stringify(this.campaignModalForm))

      const { deliveryMethod, auto_adjust, ...submitParams } = params
      if (!submitParams.budget) submitParams.day_budget = 0

      // 智能操盘
      if (deliveryMethod === 2) {
        submitParams.auto_adjust = auto_adjust
      }
      // 全自动投放 ref https://developers.e.kuaishou.com/docs?docType=DSP&documentId=2259&menuId=2804
      if (deliveryMethod === 3) {
        submitParams.auto_adjust = 1
        submitParams.auto_build = 1
        submitParams.auto_manage = 1
      }

      this.resultData = []
      this.submitLoading = true
      addCampaignBatch(Object.assign(submitParams, { start_num, end_num }))
        .then((data) => {
          this.submitLoading = false
          if (isArray(data)) {
            this.preloadData()
            this.onModalCancel()
            // 弹窗表格
            timeout(600).then(() => {
              this.result = true
              this.resultData = data
            })
          }
        })
        .catch((err) => {
          console.error(err)
          this.submitLoading = false
        })
    },
    submitToNext() {
      let temAccount
      this.resetValid()
      if (this.campaign.subject === 1 && !this.multCampaign.length) {
        this.errRes.push({ feild: '推广计划', msg: '推广计划还未选择' })
        this.formErr = true
      }
      if (this.campaign.subject === 2 && !this.multAccount.length) {
        this.errRes.push({ feild: '推广账号', msg: '推广账号还未选择' })
        this.formErr = true
      }
      if (this.campaign.budget === 1 && this.campaign.subject === 2) {
        if (!this.campaign.day_budget) {
          this.errRes.push({ feild: '推广计划预算', msg: '推广计划预算不能为空！' })
          this.formErr = true
        } else if (
          Number(this.campaign.day_budget) < 500 ||
          Number(this.campaign.day_budget) > 100000000 ||
          isNaN(Number(this.campaign.day_budget))
        ) {
          this.errRes.push({ feild: '推广计划预算', msg: '推广计划预算请输入500-100,000,000数值！' })
          this.formErr = true
        }
      }
      if (this.errRes.length) return // 如果错误中断

      // 提交时写入session
      if (this.campaign.subject === 1) {
        temAccount = this.campaignIds.filter((ret) => ret.children.some((met) => met.check))
        setSession('campaign_ids', this.multCampaign)
      } else {
        const campaign_params = {
          bid_type: this.campaign.bid_type,
          budget: this.campaign.budget,
          day_budget: this.campaign.day_budget,
          campaign_type: this.campaign.campaign_type,
          auto_adjust: this.campaign.auto_adjust
        }

        if (this.campaign.deliveryMethod === 3) {
          campaign_params.auto_adjust = 1
          campaign_params.auto_build = 1
          campaign_params.auto_manage = 1
        }

        setSession('campaign_params', campaign_params)
        temAccount = this.multAccount
      }
      // 设置账号
      setSession('ad_account_ids', temAccount)
      setSession('batch_task_type', this.campaign.subject)
      setSession('campaign_type', this.campaign.campaign_type)
      // 投放方式
      setSession('deliveryMethod', this.campaign.deliveryMethod)
      setLocal('kuaishou_campaign_type', this.campaign.campaign_type)
      // 在session中写入时间戳，getLocalforage 用来标记在indexedDB中的数据
      setSession('plan_timestamp', Date.now())
      if (this.campaign.subject === 1) setSession('bid_type', { bid_type: this.campaign.bid_type })
      this.$router.push({ name: 'kuaishoulocalplan' })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-group {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);
  }

  ::v-deep .row-item {
    align-items: flex-start;

    span.item-field {
      height: 32px;
      line-height: 32px;
    }

    .col-pull-right {
      text-align: right;
    }
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
